

import Vue from 'vue';
import { computed, onMounted, onUnmounted, ref } from "vue"
import { Component, Prop, Watch } from 'vue-property-decorator';
import { FilterFields } from  '@/models/repsol-template.model';
import  RepsolDualListComponent from '../repsol-dual-list/RepsolDualListComponent.vue'
import { tUi } from '@/utils/translate';

@Component({
    name: 'RepsolFilterBarComponent',
    components: { RepsolDualListComponent }
})

export default class RepsolFilterBarComponent extends Vue {

    isOpen = false;

    @Prop()
    filterFields : FilterFields[];

    @Prop()
    deleteFilter!: string;
    @Watch('deleteFilter')
    removeFilter(val: string): void {
        this.addParamsToLocation();
    }

    @Prop()
    changeVisibility!: boolean;
    @Watch('changeVisibility')
    changeStatus(val: boolean): void {
        this.isOpen = val
    }

    @Watch('isOpen')
    checkOpen(val: boolean): void {
        if (!val) {
        this.$emit('closeFilters')
        }
    }

    translate(value: string, params?: Record<string, unknown>): string {
        return tUi(value, params);
    }

    translateItemText(value: any): string {
        if (value == null) {
            return '';
        }

        if (typeof value === 'string') {
            return this.translate(value);
        }

        if (typeof value === 'object') {
            return this.translate(value.nombre ?? value.name ?? value.id ?? '');
        }

        return this.translate(String(value));
    }

    translatedItems(items: any[] | undefined): any[] {
        if (!Array.isArray(items)) {
            return [];
        }

        return items.map((item) => {
            if (item == null || typeof item !== 'object') {
                return item;
            }

            return {
                ...item,
                nombre: this.translateItemText(item),
                name: this.translateItemText(item),
            };
        });
    }

    height = window.innerHeight;
    mounted() {
        window.addEventListener('resize', () => {
            this.height = window.innerHeight
        });

        this.readParamsToLocation();
    }

    cleanFilterAvisos(): void {
        this.filterFields.forEach(ff => {
            if(Array.isArray(ff.model)){
                ff.model = [];
            }else{
                ff.model = '';
            }
        });
        this.applyFilterAvisos();

    }

    applyFilterAvisos(): void {
        this.addParamsToLocation();
        this.$emit("changeFilters");
    }

    addParamsToLocation() {
        const keyValue:any[] = [];
        this.filterFields.forEach(f =>{
            if(f.model){
                if(Array.isArray(f.model)){
                    f.model.forEach(m =>{
                        keyValue.push({clave:`${f.name}-${m.id}`, valor:m.nombre});
                    })
                }
                else if(typeof f.model == 'string')
                {
                    keyValue.push({clave:`${f.name}`, valor: f.model });
                }else {
                    keyValue.push({clave:`${f.name}-sm`, valor: `${f.model['id']}_${f.model['nombre']}`});
                }
            }
        });

        history.pushState(
            {},
            '',
            this.$route.path +
            '?' +
            keyValue
                .map(key => {
                return (
                    'q-'+encodeURIComponent(key.clave) + '=' + encodeURIComponent(key.valor)
                )
                })
                .join('&')
        )
    }

    readParamsToLocation() {
        for(let clave in this.$route.query){
            let valor = this.$route.query[clave];
            if(valor && clave.startsWith('q-')){
                clave = clave.substring(2);
                if(clave.endsWith('-sm')){
                    if(typeof valor == 'string'){
                        let [id, ...nombre] = valor.split('_');
                        this.setModelFilter(clave.substring(0, clave.indexOf('-sm')), {id, nombre:nombre.join('_')});
                    }
                } else if(clave.includes('-')){
                    let [name, ...id] = clave.split('-');
                    this.setModelFilter(name, {id:id.join('-'), nombre:valor}, true);
                } else {
                    this.setModelFilter(clave, valor);
                }
            }
        }

        this.applyFilterAvisos();
    }

    setModelFilter(name, value, isArray = false){
        var field = this.filterFields.find(ff => ff.name == name);
        if(!field) return;
        if(isArray && Array.isArray(field.model)) {
            if(!field.model) {
                field.model = []
            }
            field.model.push(value);
        } else{
            field.model = value;
        }

    }
}

Vue.component('repsol-filter-bar', RepsolFilterBarComponent);
